import { Row } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { $ticketDirection } from '../../_state/scaleTicketPro.state';
import { SalesRootLayout } from '../_layouts/SalesRootLayout';

import { InboundTicketDetail } from './inbound/_InboundTicketDetail';
import { OutboundTicketDetail } from './outbound/_OutboundTicketDetail';
import { ScaleTicketProView } from './shared/_ScaleTicketProView';
import { TicketSidebar } from './shared/TicketSidebar';
import { TouchModeEditModal } from './shared/TouchModeEditModal';

export const ScaleTicketDetailView = () => {
  const direction = useAtomValue($ticketDirection);

  return (
    <>
      <ScaleTicketProView className="@ScaleTicketDetailView">
        <SalesRootLayout className="p-3.5">
          <Row gap1 className="h-full w-full">
            <TicketSidebar />
            {direction === 'inbound' ? (
              <InboundTicketDetail />
            ) : (
              <OutboundTicketDetail />
            )}
          </Row>
        </SalesRootLayout>
      </ScaleTicketProView>
      <TouchModeEditModal />
    </>
  );
};
